/** Element-wise `Object.is`, the same compare React applies to an effect's deps. */
export function sameInputs(prev: readonly unknown[] | null, next: readonly unknown[]): boolean {
  return prev !== null && prev.length === next.length && prev.every((v, i) => Object.is(v, next[i]))
}
